import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_mst_branch_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  comp_guid: string;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.TextDatatypeInterface;
  abbreviation: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  tax_registration_id: fromDatatype.VarcharDatatypeInterface;
  ccy_code: fromDatatype.CurrencyCodeDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  date_created: fromDatatype.TimestampTzDatatypeInterface;
  date_updated: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  property_json: {};
  log_json: fromDatatype.JsonDatatypeInterface;
  entity_line_guid: fromDatatype.GuidDataFieldInterface;
  entity_branch_hdr_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  default_pricing_scheme: fromDatatype.VarcharDatatypeInterface;
  location_guid: fromDatatype.GuidDataFieldInterface;
  geoloc_latitude: fromDatatype.NumericDatatypeInterface;
  geoloc_longitude: fromDatatype.NumericDatatypeInterface;
  tax_applicable: boolean;
  email: fromDatatype.VarcharDatatypeInterface;
  warehouse_location_guid: fromDatatype.GuidDataFieldInterface;
  item_category_group_guid: fromDatatype.GuidDataFieldInterface;
  address_line_1: fromDatatype.VarcharDatatypeInterface;
  address_line_2: fromDatatype.VarcharDatatypeInterface;
  address_line_3: fromDatatype.VarcharDatatypeInterface;
  address_line_4: fromDatatype.VarcharDatatypeInterface;
  address_line_5: fromDatatype.VarcharDatatypeInterface;
  postal_code: fromDatatype.VarcharDatatypeInterface;
  city: fromDatatype.VarcharDatatypeInterface;
  state: fromDatatype.VarcharDatatypeInterface;
  country: fromDatatype.VarcharDatatypeInterface;
  rounding_five_cent: boolean;
  rounding_item_guid: fromDatatype.GuidDataFieldInterface;
  group_discount_item_guid: fromDatatype.GuidDataFieldInterface;
  default_sales_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  default_settlement_method_json: fromDatatype.JsonDatatypeInterface;
  phone: fromDatatype.VarcharDatatypeInterface;
  phone2: fromDatatype.VarcharDatatypeInterface;
  default_timezone: fromDatatype.VarcharDatatypeInterface;
  xtn_mapping_source_01: fromDatatype.VarcharDatatypeInterface;
  xtn_mapping_table_01: fromDatatype.VarcharDatatypeInterface;
  xtn_mapping_value_01: fromDatatype.VarcharDatatypeInterface;
  xtn_mapping_source_02: fromDatatype.VarcharDatatypeInterface;
  xtn_mapping_table_02: fromDatatype.VarcharDatatypeInterface;
  xtn_mapping_value_02: fromDatatype.VarcharDatatypeInterface;
  xtn_mapping_source_03: fromDatatype.VarcharDatatypeInterface;
  xtn_mapping_table_03: fromDatatype.VarcharDatatypeInterface;
  xtn_mapping_value_03: fromDatatype.VarcharDatatypeInterface;
  xtn_mapping_source_04: fromDatatype.VarcharDatatypeInterface;
  xtn_mapping_table_04: fromDatatype.VarcharDatatypeInterface;
  xtn_mapping_value_04: fromDatatype.VarcharDatatypeInterface;
  xtn_mapping_source_05: fromDatatype.VarcharDatatypeInterface;
  xtn_mapping_table_05: fromDatatype.VarcharDatatypeInterface;
  xtn_mapping_value_05: fromDatatype.VarcharDatatypeInterface;
  branch_ref1: fromDatatype.VarcharDatatypeInterface;
  branch_ref2: fromDatatype.VarcharDatatypeInterface;
  branch_ref3: fromDatatype.VarcharDatatypeInterface;
  parent_branch_guid: fromDatatype.GuidDataFieldInterface;
  skip_einvoice: boolean;
  notification_template_hdr_guid: fromDatatype.GuidDataFieldInterface;
  pin_number_json: {};
}

export class bl_fi_mst_branch_RowClass
  implements bl_fi_mst_branch_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  comp_guid: string;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.TextDatatypeInterface;
  abbreviation: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  tax_registration_id: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  date_created: fromDatatype.TimestampTzDatatypeInterface;
  date_updated: fromDatatype.TimestampTzDatatypeInterface;
  ccy_code: fromDatatype.CurrencyCodeDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  property_json: {};
  log_json: fromDatatype.JsonDatatypeInterface;
  entity_line_guid: fromDatatype.GuidDataFieldInterface;
  entity_branch_hdr_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  default_pricing_scheme: fromDatatype.VarcharDatatypeInterface;
  location_guid: fromDatatype.GuidDataFieldInterface;
  geoloc_latitude: fromDatatype.NumericDatatypeInterface;
  geoloc_longitude: fromDatatype.NumericDatatypeInterface;
  tax_applicable: boolean;
  email: fromDatatype.VarcharDatatypeInterface;
  warehouse_location_guid: fromDatatype.GuidDataFieldInterface;
  item_category_group_guid: fromDatatype.GuidDataFieldInterface;
  address_line_1: fromDatatype.VarcharDatatypeInterface;
  address_line_2: fromDatatype.VarcharDatatypeInterface;
  address_line_3: fromDatatype.VarcharDatatypeInterface;
  address_line_4: fromDatatype.VarcharDatatypeInterface;
  address_line_5: fromDatatype.VarcharDatatypeInterface;
  postal_code: fromDatatype.VarcharDatatypeInterface;
  city: fromDatatype.VarcharDatatypeInterface;
  state: fromDatatype.VarcharDatatypeInterface;
  country: fromDatatype.VarcharDatatypeInterface;
  rounding_five_cent: boolean;
  rounding_item_guid: fromDatatype.GuidDataFieldInterface;
  group_discount_item_guid: fromDatatype.GuidDataFieldInterface;
  default_sales_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  default_settlement_method_json: fromDatatype.JsonDatatypeInterface;
  phone: fromDatatype.VarcharDatatypeInterface;
  phone2: fromDatatype.VarcharDatatypeInterface;
  default_timezone: fromDatatype.VarcharDatatypeInterface;
  xtn_mapping_source_01: fromDatatype.VarcharDatatypeInterface;
  xtn_mapping_table_01: fromDatatype.VarcharDatatypeInterface;
  xtn_mapping_value_01: fromDatatype.VarcharDatatypeInterface;
  xtn_mapping_source_02: fromDatatype.VarcharDatatypeInterface;
  xtn_mapping_table_02: fromDatatype.VarcharDatatypeInterface;
  xtn_mapping_value_02: fromDatatype.VarcharDatatypeInterface;
  xtn_mapping_source_03: fromDatatype.VarcharDatatypeInterface;
  xtn_mapping_table_03: fromDatatype.VarcharDatatypeInterface;
  xtn_mapping_value_03: fromDatatype.VarcharDatatypeInterface;
  xtn_mapping_source_04: fromDatatype.VarcharDatatypeInterface;
  xtn_mapping_table_04: fromDatatype.VarcharDatatypeInterface;
  xtn_mapping_value_04: fromDatatype.VarcharDatatypeInterface;
  xtn_mapping_source_05: fromDatatype.VarcharDatatypeInterface;
  xtn_mapping_table_05: fromDatatype.VarcharDatatypeInterface;
  xtn_mapping_value_05: fromDatatype.VarcharDatatypeInterface;
  branch_ref1: fromDatatype.VarcharDatatypeInterface;
  branch_ref2: fromDatatype.VarcharDatatypeInterface;
  branch_ref3: fromDatatype.VarcharDatatypeInterface;
  parent_branch_guid: fromDatatype.GuidDataFieldInterface;
  skip_einvoice: boolean;
  notification_template_hdr_guid: fromDatatype.GuidDataFieldInterface;
  pin_number_json: {};
}
